import { useAtomValue } from "jotai";

import { updateGolfBookingPayloadAtom } from "../../../atoms/selectors/UpdatePayloads/updateGolfBookingPayload/updateGolfBookingPayloadAtom";
import { useUpdateSingleSlotBookingMutation } from "./useUpdateSingleSlotBooking";

export const useTransferBookingOwnershipAndLeave = () => {
  const updateGolfBookingPayload = useAtomValue(updateGolfBookingPayloadAtom);

  const [handleUpdateBooking, isUpdating] =
    useUpdateSingleSlotBookingMutation();

  const bookingId = updateGolfBookingPayload?.bookingId;

  const handleRemoveAndTransferOwnership = (
    currentMemberId: string,
    newOwnerClientId: string,
    successCallback?: () => void
  ) => {
    const memberRoundsWithoutCurrentMember =
      updateGolfBookingPayload?.memberRounds?.filter(
        (p) => p?.playerId !== currentMemberId
      );

    handleUpdateBooking(
      {
        bookingId: bookingId ?? "",
        ...updateGolfBookingPayload,
        memberRounds: memberRoundsWithoutCurrentMember,
        notifyMember: true,
        ownerClientId: newOwnerClientId,
      },
      successCallback
    );
  };

  return [handleRemoveAndTransferOwnership, isUpdating] as const;
};
